import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

import IcGreenArrowLeft from "../../../../resources/icons/arrows/ic_green_arrow_left.js";
import IcGreenArrowRight from "../../../../resources/icons/arrows/ic_green_arrow_right.js";

const scrollingThreshold = 20;

const styles = theme => ({
  root: {
    position: "relative",
  },
  container: {
    display: "block",
    whiteSpace: "nowrap",
    overflowX: "scroll",
    overflowY: "hidden",
    scrollBehavior: "smooth",
    scrollbarWidth: "none",
    "-webkitOverflowScrolling": "touch",
    "-msOverflowStyle": "none",

    "& > *": {
      whiteSpace: "normal",
      verticalAlign: "top",
    },

    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  arrow: {
    border: "none",
    outline: "none",
    position: "absolute",
    backgroundColor: "transparent",
    top: "50%",
    marginTop: "-25px",
    display: "block",
    padding: "0",
    height: "40px",
    width: "40px",
    zIndex: "1",
    ['@media (max-width: 992px)']: {
      marginTop: "-25px",
    },
    ['@media (max-width: 768px)']: {
      display: "none"
    },
  },
  arrowLeft: {
    left: "-8px",
  },
  arrowRight: {
    right: "-8px",
  },
  arrowDisabled: {
    opacity: "0.5"
  }
});


class Scroller extends React.Component {
  constructor(props) {
    super(props);

    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.scrollTo = this.scrollTo.bind(this);

    this.state = {
      disableLeft: true,
      disableRight: false
    }
  }

  componentDidMount() {
    this.itemWidth = this.scrollerRef.firstChild.offsetWidth;
    this.scrollerRef.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    this.onScroll();
  }

  componentWillUnmount() {
    this.scrollerRef.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps) {
    if(this.props.hasMore && prevProps.children.length < this.props.children.length) {
      this.onScroll();
    }
  }

  scrollTo(element, offset, callback, direction) {
    if(!element) return;

    const onScroll = function () {
      const scrollLeft = element.scrollLeft || element.pageXOffset
      if(direction === 'left') {
        if(scrollLeft === offset || scrollLeft === 0 || !scrollLeft) {
          element.removeEventListener('scroll', onScroll)
          callback()
        }
      } else {
        if(scrollLeft >= offset - scrollingThreshold || scrollLeft >= element.scrollWidth - element.offsetWidth - scrollingThreshold){
          element.removeEventListener('scroll', onScroll)
          callback()
        }
      }
    }
    element.addEventListener('scroll', onScroll)
    onScroll()
    element.scrollTo({
        left: offset,
        behavior: 'smooth'
    })
  }

  onScroll() {
    const { disableLeft, disableRight, scrolling } = this.state;
    if(scrolling) return;
    if(this.scrollerRef.scrollLeft <= scrollingThreshold && !disableLeft) {
      this.setState({disableLeft: true});
    } 
  
    if(disableLeft && this.scrollerRef.scrollLeft > scrollingThreshold) {
      this.setState({disableLeft: false});
    }

    if(!disableRight && this.scrollerRef.scrollLeft >= this.scrollerRef.scrollWidth - this.scrollerRef.offsetWidth - scrollingThreshold ) {
      this.setState({disableRight: true});
    }

    if(disableRight && this.scrollerRef.scrollLeft < this.scrollerRef.scrollWidth - this.scrollerRef.offsetWidth) {
      this.setState({disableRight: false});
    }
  }

  onResize() {
    this.onScroll();
    this.itemWidth = this.scrollerRef.firstChild.offsetWidth;
  }

  onPrevClick() {
    if(this.state.scrolling || this.state.disableLeft) return;
    const currentScroll = this.scrollerRef.scrollLeft;
    if(this.scrollerRef.scrollTo) {
      this.setState({scrolling: true});
      this.scrollerRef.scrollTo({left: currentScroll - this.itemWidth * 2, behavior: 'smooth'})

      this.scrollTo(
        this.scrollerRef,
        currentScroll - this.itemWidth * 2,
        () => {
          this.setState({scrolling: false});
          this.onScroll();
        },
        'left'
      )

    } else {
      this.scrollerRef.scrollLeft = currentScroll - this.itemWidth * 2;
    }
  }

  onNextClick() {
    if(this.state.scrolling || this.state.disableRight) return;
    const currentScroll = this.scrollerRef.scrollLeft;

    if(this.scrollerRef.scrollTo) {
      this.setState({scrolling: true});

      this.scrollTo(
        this.scrollerRef,
        currentScroll + this.itemWidth * 2,
        () => {
          this.setState({scrolling: false});
          this.onScroll();
        },
        'right'
      )

    } else {
      this.scrollerRef.scrollLeft = currentScroll + this.itemWidth * 2;
    }
  }

  render() {
    const { disableLeft, disableRight, scrolling } = this.state;
    const { classes, className } = this.props;
    const disableNavigation = !!disableLeft && !!disableRight;

    return (
      <div className = { clsx(classes.root, className) }>
        {
          !disableNavigation && (
            <button className = { clsx(classes.arrow, classes.arrowLeft, (disableLeft || scrolling ? classes.arrowDisabled : '') )} 
                    onClick = { this.onPrevClick }>
              <IcGreenArrowLeft/>
            </button>  
          )
        }
        <div
          className = { classes.container }
          ref={(ref) => this.scrollerRef = ref}
        >
          {this.props.children}
        </div>
        {
          !disableNavigation && (
            <button className = { clsx(classes.arrow, classes.arrowRight, (disableRight || scrolling ? classes.arrowDisabled : '') )} 
                    onClick = { this.onNextClick }>
              <IcGreenArrowRight/>
            </button>  
          )
        }
      </div>
    )
  }
}

Scroller.defaultProps = {
  hasMore: false
}

export default withStyles(styles)(Scroller);